import { Component, OnInit, ElementRef, Input, forwardRef, Renderer, Injector } from '@angular/core';
import { BaseAbstractControl, mohValidators } from 'moh-package';
import { FormGroup, FormControl, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { GazzezetService } from '../../../services/general/gazzezet.service';

@Component({
  selector: 'moh-gzz-bank-account-details',
  templateUrl: './gzz-bank-account-details.component.html',
  styleUrls: ['./gzz-bank-account-details.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => GzzBankAccountDetailsComponent) },
    { provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => GzzBankAccountDetailsComponent) }]
})
export class GzzBankAccountDetailsComponent extends BaseAbstractControl implements OnInit {

  banksList: any[] = [];
  bankBranchesList: any[] = [];
  filteredBranchesList: any[] = [];

  constructor(injector: Injector, private gazzezetService: GazzezetService) {
    super(injector);
  }

  ngOnInit() {

    this.initializeFormGroup()

    this.initializeBankAccountLists();

    super.ngOnInit();
  }

  initializeFormGroup() {

    this.baseAbstractControl = new FormGroup({

      OwnerName: new FormControl('', [mohValidators.required(), mohValidators.maxLength(50), mohValidators.pattern(new RegExp("^[{א-ת} \"']*$"))]),
      OwnerID: new FormControl('', [mohValidators.required(), mohValidators.idNumber()]),
      Bank: new FormControl('', [mohValidators.required()]),//TODO: set bank name to object
      Branch: new FormControl(0, [mohValidators.required()]),
      AccountNumber: new FormControl('', [mohValidators.required()])
    });
  }

  initializeBankAccountLists() {
    
    var observables: Observable<any[]>[] = [];

    observables.push(this.gazzezetService.getBanksList());
    observables.push(this.gazzezetService.getBankBranchesList());

    var values = combineLatest(observables, (banks, branches) => {
      return { banks, branches };
    })
      .subscribe(values => {
        this.banksList = values.banks;
        this.bankBranchesList = values.branches;
      });

    (<FormControl>(<FormGroup>this.baseAbstractControl).controls.Bank).valueChanges.subscribe(val => {
      if (val && val.Bank_Code) {
        this.filteredBranchesList = this.bankBranchesList.filter(x => x.Bank_Code === val.Bank_Code);
        (<FormGroup>this.baseAbstractControl).controls.Branch.setValue(null);
      }
    });
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/general/gzz-bank-account-details/gzz-bank-account-details.component.ts